import axios from 'axios'
import qs from 'qs'
import { getToken, getUserUUID, removeToken, removeUserInfo } from '@/utils/auth'
import { Message } from 'view-design'
import store from '@/store'
import router from '@/router'
axios.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === -401) {
      // 只能弹一次
      let isErrorTip = localStorage.getItem('isErrorTip') ? localStorage.getItem('isErrorTip') : 0
      if (isErrorTip == 0) {
        Message.error('登陆过期，请重新登录')
        localStorage.setItem('isErrorTip', 1)
      }
      store.dispatch('nav/changeIsGoOfficial', 0)
      store.dispatch('user/logout')
      if (store.state.user.isSaasProxyUser == 1) {
        router.push('/pc/proxyHome/index')
      } else {
        router.push('/')
      }
    } else if (res.code) {
      return response
    } else {
      // 如果res 返回的是字符串格式的-支付宝接口对应的返回
      if (typeof res === 'string') {
        return response
      } else if (typeof res === 'object') {
        return response
      } else {
        // 其他未知的情况
        return Promise.reject(new Error(res.message || '系统异常！请稍后再试！'))
      }
    }
  },
  error => {
    let errorResponse = error.response
    if (errorResponse && errorResponse.data) {
      let errorData = errorResponse.data
      if (errorData.status && errorData.status == 500) {
        if (errorData.message == 'token超时，请重新登录' || errorData.message == '请先登录账号' || errorData.message == 'error openUser') {
          // 只能弹一次
          let isErrorTip = localStorage.getItem('isErrorTip') ? localStorage.getItem('isErrorTip') : 0
          if (isErrorTip == 0) {
            Message.error('登陆过期，请重新登录')
            localStorage.setItem('isErrorTip', 1)
          }
          store.dispatch('nav/changeIsGoOfficial', 0)
          store.dispatch('user/logout')
          router.push('/')
          return Promise.reject('token invalid')
        } else {
          return Promise.reject(errorData.message || '系统异常！请稍后再试！')
        }
      }
    }
    return Promise.reject(error)
  }
)
export class Http {
  constructor(arg) {
    this.$axios = axios;
    this.qs = qs;
    this.host = process.env.VUE_APP_HOST;
    this.kfc_host = process.env.VUE_APP_KFC_AUTH_URL
    this.open_host = process.env.VUE_APP_PROXY_TARGET_JAVA
    this.saas_host = process.env.VUE_APP_SAAS_MOVIE_DOMAIN
    this.piaoshang_host = process.env.VUE_APP_NEW_OPEN_URL
    this.mini_host = process.env.VUE_APP_NEW_OPEN_URL
    this.java_host = process.env.VUE_APP_MOVIE_DOMAIN
  }
  getAjax(url, data) {
    //java不需要拼movie/
    if (url.indexOf('yp-api') !== -1) {
      this.host = this.host.replace('movie/', '')
    }
    return this.$axios.get(`${this.host}${url}`, {
      method: 'get',
      params: {
        ...data
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-token": getToken(),
        "uuid": getUserUUID(),
        "java-token": localStorage.getItem('java-token')
      }
    })
  }

  

  postAjax(url, data) {
    if (url.indexOf('yp-api') !== -1) {
      this.host = this.host.replace('movie/', '')
      //this.host = 'http://172.16.102.122:8082/'
    }
    //跨域问题：this.qs.stringify解决
    return this.$axios.post(`${this.host}${url}`, this.qs.stringify({
      ...data,
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-token": getToken(),
        "uuid": getUserUUID()
      }
    })
  }

  postAjax222(url, data) {
    // if (url.indexOf('yp-api') !== -1) {
    //   // this.host = this.host.replace('movie/', '')
    //   this.host = 'https://open.lingdianhaowu.com/'
    // }
    const host = 'https://open.lingdianhaowu.com/'
    //跨域问题：this.qs.stringify解决
    return this.$axios.post(`${this.piaoshang_host}${url}`, this.qs.stringify({
      ...data,
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-token": getToken(),
        "uuid": getUserUUID()
      }
    })
  }

  postAjaxExport(url, data) {
    if (url.indexOf('yp-api') !== -1) {
      this.host = this.host.replace('movie/', '')
      //this.host = 'http://172.16.102.122:8082/'
    }
    //跨域问题：this.qs.stringify解决
    return this.$axios.post(`${this.host}${url}`, this.qs.stringify({
      ...data,
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-token": getToken(),
        "uuid": getUserUUID()
      },
      responseType: 'arraybuffer'
    })
  }
  // 肯德基请求
  postAjaxByKfc(url, data) {
    //跨域问题：this.qs.stringify解决
    return this.$axios.post(`${this.kfc_host}${url}`, this.qs.stringify({
      ...data,
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-token": getToken(),
        "uuid": getUserUUID()
      }
    })
  }

  // 肯德基导出excel请求
  postAjaxByKfcExport(url, data) {
    //跨域问题：this.qs.stringify解决
    return this.$axios.post(`${this.kfc_host}${url}`, this.qs.stringify({
      ...data,
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-token": getToken(),
        "uuid": getUserUUID()
      },
      responseType: 'arraybuffer'
    })
  }
  // 开发平台请求
  postOpenAjax(url, data) {
    console.log('this.open_host', this.open_host)
    // this.open_host = 'http://172.16.102.228:8201/'
    if (url.indexOf('yp-api') !== -1) {
      this.open_host = this.open_host.replace('movie/', '')
      // this.open_host = 'http://172.16.102.228:8201/'
    }
    //跨域问题：this.qs.stringify解决
    return this.$axios.post(`${this.open_host}${url}`, this.qs.stringify({
      ...data,
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "TOKEN": localStorage.getItem('java-token'),
        "X-Token": getToken(),
        "uuid": getUserUUID()
      }
    })
  }
  // saas加盟请求
  postAjaxBySaas(url, data, message) {
    //跨域问题：this.qs.stringify解决
    if (message) {
      this.saas_host = process.env.VUE_APP_NEW_OPEN_URL
    } else {
      this.saas_host = process.env.VUE_APP_SAAS_MOVIE_DOMAIN
    }
    return this.$axios.post(`${this.saas_host}${url}`, this.qs.stringify({
      ...data,
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-token": getToken(),
        "uuid": getUserUUID(),
        "OPENTOKEN": localStorage.getItem('java-open-token'),
      }
    })
  }
  postAjaxByMini(url, data, isExport) {
    //跨域问题：this.qs.stringify解决
    return this.$axios.post(`${this.mini_host}${url}`, this.qs.stringify({
      ...data,
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "x-token": getToken(),
        "uuid": getUserUUID(),
        "OPENTOKEN": localStorage.getItem('java-open-token'),
      },
    })
  }
  // get请求
  getAjaxByMini(url, data) {
    return this.$axios.get(`${this.mini_host}${url}`, {
      method: 'get',
      params: {
        ...data
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-token": getToken(),
        "uuid": getUserUUID(),
        "OPENTOKEN": localStorage.getItem('java-open-token')
      }
    })
  }
  postAjaxByMiniNew(url, data, isExport) {
    //跨域问题：this.qs.stringify解决
    return this.$axios.post(`${this.mini_host}${url}`, data, {
      headers: {
        "Content-Type": "application/json",
        "x-token": getToken(),
        "uuid": getUserUUID(),
        "OPENTOKEN": localStorage.getItem('java-open-token'),
      },
    })
  }
  postAjaxByDouYin(url, data, isFormContentType) {
    let contentType = !isFormContentType ? 'application/json;charset=UTF-8' : 'application/x-www-form-urlencoded'
    let query = !isFormContentType ? {
      ...data
    } : this.qs.stringify({
      ...data,
    })
    console.log(contentType,'contentTypecontentType')
    return this.$axios.post(`${this.mini_host}${url}`, query, {
      headers: {
        "Content-Type": contentType,
        "x-token": getToken(),
        "uuid": getUserUUID(),
        "OPENTOKEN": localStorage.getItem('java-open-token'),
      }
    })
  }
  // 小程序导出
  postAjaxByMiniExport(url, data) {
    //跨域问题：this.qs.stringify解决
    return this.$axios.post(`${this.mini_host}${url}`, this.qs.stringify({
      ...data,
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-token": getToken(),
        "uuid": getUserUUID(),
        "OPENTOKEN": localStorage.getItem('java-open-token'),
      },
      responseType: 'arraybuffer'
    })
  }
  postAjaxBySaasTicket(url, data) {
    //跨域问题：this.qs.stringify解决
    // return this.$axios.post(`${this.saas_host}${url}`, this.qs.stringify({
    //   ...data,
    // }), {
    //   headers: {
    //     "Content-Type": "application/json",
    //     "x-token": getToken(),
    //     "uuid": getUserUUID(),
    //     // "OPENTOKEN":'eyJ0eXBlIjoiSldUIiwiYWxnIjoiSFMyNTYifQ.eyJVU0VSVVVJRCI6InlyZHRlc3QiLCJGQU5TX0lEIjoxOCwiQVBQX0tFWSI6IjE1NzIwNjAxOTcxIiwiZXhwIjoxNjU2Njc5NzkyLCJuYmYiOjE2NTYxNzkxMzd9.KafHkHI7WvXAPQLDxOTOWC1jgyXQaMptfCc5AWs5anQ'
    //     "OPENTOKEN":localStorage.getItem('java-open-token'),
    //   }
    // })
    return this.$axios.post(`${this.saas_host}${url}`, {
      ...data
    }, {
      headers: {
        "Content-Type": "application/json",
        "OPENTOKEN": localStorage.getItem('java-open-token'),
      }
    })
  }
  postAjaxBySaasExport(url, data) {
    //跨域问题：this.qs.stringify解决
    return this.$axios.post(`${this.saas_host}${url}`, this.qs.stringify({
      ...data,
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "OPENTOKEN": localStorage.getItem('java-open-token'),
        "uuid": getUserUUID()
      },
      responseType: 'arraybuffer'
    })
  }
  postAjaxByTb(url, data) {
    //跨域问题：this.qs.stringify解决
    console.log("debug:________________this.java_host______________", this.java_host);
    console.log("debug:________________url______________", url);
    return this.$axios.post(`${this.java_host}${url}`, this.qs.stringify({
      ...data,
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "x-token": getToken(),
        "uuid": getUserUUID(),
        "OPENTOKEN": localStorage.getItem('java-open-token'),
      },
    })
  }
  
}



// WEBPACK FOOTER //
// ./src/model/Http.js